import { render, staticRenderFns } from "./ShipParticular.vue?vue&type=template&id=55a7ccf4&scoped=true&"
import script from "./ShipParticular.vue?vue&type=script&lang=js&"
export * from "./ShipParticular.vue?vue&type=script&lang=js&"
import style0 from "./ShipParticular.vue?vue&type=style&index=0&id=55a7ccf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7ccf4",
  null
  
)

export default component.exports